// extracted by mini-css-extract-plugin
export var backupIcon = "_n4-1";
export var image = "_n4-0";